import { render, staticRenderFns } from "./CompanyItemCategorySetting.vue?vue&type=template&id=44450e36&scoped=true"
import script from "./CompanyItemCategorySetting.vue?vue&type=script&lang=js"
export * from "./CompanyItemCategorySetting.vue?vue&type=script&lang=js"
import style0 from "./CompanyItemCategorySetting.vue?vue&type=style&index=0&id=44450e36&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44450e36",
  null
  
)

export default component.exports